import React from 'react';
import EnsuringDocumentHandling from '../Assets/Img/EnsuringDocumentHandling/Ensuring Secure Document Handling.pdf';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import MediaQuery from 'react-responsive';


export default function DocumentProcessingVsDocumentManagement() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    return (
        <>
            {/* Laptop mode */}
            <MediaQuery minWidth={1160}>
                <div className='container-fluid' style={{ height: '100vh' }}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={EnsuringDocumentHandling}
                            plugins={[defaultLayoutPluginInstance]}
                            defaultScale={1} // Set the default scale to 1 (100%)
                        // theme="dark" // Set the theme to "dark"
                        />
                    </Worker>
                    {/* <style>
                {`
                    .rpv-core__icon {
                        display: none !important;
                    }
                `}  
            </style> */}
                </div>
            </MediaQuery>



            {/* Tablet or ipad mode  */}
            <MediaQuery minWidth={768} maxWidth={1159}>
                <div className='container-fluid' style={{ height: '100vh' }}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={EnsuringDocumentHandling}
                            plugins={[defaultLayoutPluginInstance]}
                            defaultScale={0.9} // Set the default scale to 1 (100%)
                        // theme="dark" // Set the theme to "dark"
                        />
                    </Worker>
                    {/* <style>
                        {`
                            .rpv-core__icon {
                                display: none !important;
                            }
                        `}  
                    </style> */}
                </div>
            </MediaQuery>

            {/* Mobile mode */}
            <MediaQuery maxWidth={767}>
                <div className='container-fluid' style={{ height: '100vh' }}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={EnsuringDocumentHandling}
                            plugins={[defaultLayoutPluginInstance]}
                            defaultScale={0.6} // Set the default scale to 1 (100%)
                        // theme="dark" // Set the theme to "dark"
                        />
                    </Worker>
                    {/* <style>
                {`
                    .rpv-core__icon {
                        display: none !important;
                    }
                `}  
            </style> */}
                </div>
            </MediaQuery>
            <div className='mx-auto' style={{
                position: 'absolute',
                top: '60px',
                left: '0',
                right: '0',
                // background:"red",
                "z-index": '-20',
                "opacity":"0",
                width:"80%",
                "pointer-events": "none",
                fontSize: '5px',
            }}>
                <h1 className='p-0 m-0' style={{fontSize:"5px"}}>Ensuring Secure Document Handling Through NSIT 800-53 Compilance</h1>
                <p>In today's digital landscape, ensuring the security of federal documents is critical for government agencies, contractors,
                    and private entities handling sensitive information. NIST 800-53 provides a comprehensive framework for implementing
                    security controls safeguarding document processing and management. This white paper outlines the challenges, best
                    practices, and compliance strategies necessary to handle document processing securely in accordance with NIST 800-
                    53.
                </p>
                <h2 className='p-0 m-0' style={{fontSize:"5px"}}>What is NIST 800-53?</h2>
                <p>NIST 800-53 is a set of security and privacy controls developed by the National Institute of Standards and Technology (NIST)
                    to help organizations protect sensitive information and ensure compliance with federal cybersecurity requirements.
                    It serves as a comprehensive guideline for managing risks associated with digital and physical information systems,
                    covering areas such as access control, data encryption, system monitoring, and incident response. Designed primarily
                    for U.S. government agencies and their contractors, NIST 800-53 provides a structured approach to strengthening
                    cybersecurity and ensuring that sensitive federal documents and data are handled securely. It can be understood as
                    a rulebook that organizations follow to keep government information safe from unauthorized access, cyber threats,
                    and data breaches.
                    <h2 className='p-0 m-0' style={{fontSize:"5px"}}>Challenges in Secure Document Processing</h2>
                    <p>Handling sensitive federal documents comes with several challenges. The biggest risk is unauthorized access to
                        confidential information, such as Controlled Unclassified Information (CUI) and Personally Identifiable Information
                        (PII). If security measures are weak, unauthorized personnel could gain access and even cybercriminals, leading to
                        data breaches.

                        Another challenge is ensuring that documents remain accurate without unauthorized unhinges. Unauthorized
                        modifications can lead to data integrity issues, making tracking and verifying documents difficult. Organizations
                        must also protect documents during transmission and storage, ensuring they are not intercepted or tampered with.
                        Additionally, automated document processing systems, such as AI-driven workflows, can introduce vulnerabilities if
                        not properly secured.</p>
                </p>

                <h2 className='p-0 m-0' style={{fontSize:"5px"}}>Secure Steps in Processing Federal Documents</h2>
                <p>To protect sensitive documents, organizations should adhere to the following steps:</p>
                <h3 className='p-0 m-0' style={{fontSize:"5px"}}>1. Classification and Access Control</h3>
                <p>Documents should be classified to determine if they contain sensitive information. Access to documents should be
                    limited using Role-Based Access Control (RBAC), ensuring that only authorized users can view or modify them. Multi-
                    Factor Authentication (MFA) should also be required before granting access to critical documents.</p>
                <h3 className='p-0 m-0' style={{fontSize:"5px"}}>Storage and Trasmission Security</h3>
                <p>
                    Documents should be encrypted when stored and sent over a network. Encryption methods such as AES-256 and TLS
                    1.2+ should be used to ensure data security. Organizations should also maintain audit logs to track who accessed or
                    modified a document and when.</p>
                <h3 className='p-0 m-0' style={{fontSize:"5px"}}>Storage and Disposal</h3>
                <p>Documents should be stored in a secure cloud environment, such as GovCloud. Organizations must also follow
                    document retention and disposal policies to ensure documents are securely stored or deleted when no longer needed</p>

                <h2 className='p-0 m-0' style={{fontSize:"5px"}}>How NIST 800-53 Ensures Secure Document Processing</h2>
                <p>The NIST 800-53 framework provides a structured approach to securing document processing by enforcing key security
                    principles. These security principles follow an implementation approach which organizations can use to ensure the security of the documents.By integrating these measures, organizations can ensure the confidentiality, integrity, and availability of sensitive
                    documents while maintaining compliance with federal security regulations</p>
                <table>
                    <tr>
                    <th>Security Principle</th>
                    <th>Implementing Approach</th>
                    </tr>
                    <tr>
                        <td>Acess Control</td>
                        <td>Enforces Role Based Access Control (RBCA) and Multi Factor Authentication (MFA)
                        to prevent unauthorized document access</td>
                    </tr>
                    <tr>
                        <td>Data Encryption</td>
                        <td>Uses AES-256 encryption for data at rest and TLS 1.2+ for secure data transmis-
                        sion.</td>
                    </tr>
                    <tr>
                        <td>Audit Logging & Monitoring</td>
                        <td>Maintains real-time logs of document access and modifications for accountability</td>
                    </tr>
                    <tr>
                        <td>Incident Response & Recov-
                        ery</td>
                        <td>Establishes and maintains proactive response plans to detect, contain, and miti-
                        gate security breaches.</td>
                    </tr>
                    <tr>
                        <td>Secure Storage & Disposal</td>
                        <td> Utilizes approved secure cloud storage and ensures safe document disposal based
                        on retention policies.</td>
                    </tr>
                </table>

                <h2 className='p-0 m-0' style={{fontSize:"5px"}}>Doc2Data.ai - A Secure Solution for Document Processing</h2>
                <p>
                    Doc2Data.ai is a cutting-edge document processing and management solution developed by Eigennet with security
                    in mind. Built on the NIST 800-53 framework and hosted in a secure GovCloud, Doc2Data.ai incorporates security
                    principles to securely process, store, and manage federal records. By leveraging a robust security system plan, along
                    with advanced vulnerability detection mechanisms, Doc2Data.ai ensures that documents that contain Personally
                    Identifiable Information (PII) and other sensitive information are processed and stored securely to prevent unauthorized
                    access, data leaks, and document tampering.
                    With a strict Role Based Access Control measure to prevent unauthorized access, a robust encryption system
                    to secure documents during transit and at rest, and with an audit log feature that provides comprehensive
                    oversight, Doc2Data.ai positions itself as a document processing system that aligns with federal security compliance
                    standards and helps organizations mitigate risks, maintains data integrity, and upholds the confidentiality, and
                    availability of critical documents.</p>
            </div>

        </>
    );
}
